import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute, PRIMARY_OUTLET } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import { environment } from 'projects/environments/environment';
import { map, first, catchError, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AppService } from '../services/app.service';
import { AuthService } from 'projects/Shared-Lib/services/auth.service';
import { ActionResultClass } from 'projects/Shared-Lib/model/search-result';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  jwtService: JwtHelperService;
  constructor(private auth: AuthService, private authService: AuthService, private logger: NGXLogger) {
    this.jwtService = new JwtHelperService();
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    let url: string = state.url;
    const tk = route.queryParams['tk'];
    // if (!this.isLoggedIn()) { // for Solve twice login issue
    if (tk) {
      await this.GetToken(tk);
    }
    // } // for Solve twice login issue
    return this.verifyLogin(url);
  }

  verifyLogin(url): boolean {
    if (!this.isLoggedIn()) {
      // this.router.navigate(['/AutoLogin']);
      this.authService.login();
      return false;
    }
    else if (this.isLoggedIn()) {
      return true;
    }
  }

  public isLoggedIn(): boolean {
    let status = false;
    let token = localStorage.getItem('access_token');
    //let userData = localStorage.getItem('user');
    //console.log(`token is expired : ${this.jwtService.isTokenExpired(token)}`);

    if (token) {
      //token 逾期，要refresh token
      if (this.jwtService.isTokenExpired(token)) {
        //console.log(`should refresh token`);
      }
      status = true;
    }
    return status;
  }

  public async GetToken(sessionId: string): Promise<void> {
    return await this.auth.SingleSignOn(sessionId);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard {
  Controller: string = 'User';
  protected BaseUrl = environment.APIBaseUrl;

  jwtService: JwtHelperService;
  constructor(private router: Router, private dataService: DataService, private http: HttpClient, private appService: AppService) {
    this.jwtService = new JwtHelperService();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    let routeData = this.GetActivedRouteData(route, 'resource');

    if (routeData && routeData['resource']) {
      return this.http.get(`${this.BaseUrl}${this.Controller}/Permission/${routeData['resource']}`).pipe(
        map((ret: any) => {
          //2021-08-23 GSSPortal Update. Change return type to BaseResultObj
          if (ret.Success) {
            let data = ret.Result;

            if (routeData['action']) {
              let permission = data.filter(x => x.ActionName === routeData['action'] && x.Enabled === true);
              if (permission && permission.length > 0) {
                if (permission[0].Enabled) {
                  return true;
                }
                else {
                  this.appService.SetErrMsg('Permission deny');
                  //redirect to home
                  this.router.navigate(['/Forbidden']);
                  return false;
                }

              }
            }
          }
          else {
            throw ret.Result;
          }

          return false;
        }),
        catchError((err) => {
          throw err;
        }),
      );
    }
    else {
      return true;
    }
  }

  GetActivedRouteData(activeRouter: ActivatedRouteSnapshot, prop: string) {
    let children: ActivatedRouteSnapshot[] = activeRouter.children;
    if (activeRouter.data.hasOwnProperty(prop)) {
      return activeRouter.data;
    }
    else {
      if (children.length === 0) {
        return {};
      }

      for (let child of children) {
        //verify primary route
        if (child.outlet !== PRIMARY_OUTLET) {
          continue;
        }
        console.log('child', child);
        if (!child.data.hasOwnProperty(prop)) {
          return this.GetActivedRouteData(child, prop);
        }
        else {
          return child.data;
        }
      }
    }
  }
}
